'use strict';

export default class Factory {
    constructor(settings) {
        this.settings = settings;
        this.elements = {};
    }

    init() {
        let elements = document.querySelectorAll(`.${this.settings.className}:not(.${this.getInitedClass()})`);
        for (let i = 0, l = elements.length; i < l; i++) {
            this.initSingle(elements[i]);
        }
    }

    getInitedClass() {
        return `${this.settings.className}-inited`;
    }

    initSingle(element) {
        const createInstance = (instance) => {
            if (this.hasClass(element, this.getInitedClass())) {
                return this.elements[element.getAttribute('data-id')] || null;
            }

            this.addClass(element, this.getInitedClass());

            let elementInstance = new instance(element);
            this.elements[elementInstance.id] = elementInstance;
            return this.elements[elementInstance.id];
        };

        let promise = new Promise((resolve, reject) => {
            if (typeof this.settings.ensure == "function") {
                this.settings.ensure(resolve, createInstance);
            } else {
                reject(null);
            }
        });

        return promise;
    }

    destroy() {
        for (let id in this.elements) {
            this.removeClass(this.elements[id].element, this.getInitedClass());
            this.elements[id].destroy();
        }
        this.elements = {};
        this.settings.classInstance.id = 0;
    }

    destroySingle(element) {
        if (!this.hasClass(element, this.getInitedClass())) {
            return element;
        }

        let id = element.getAttribute('data-id');
        if (!id || !this.elements[id]) {
            return;
        }
        this.removeClass(this.elements[id].element, this.getInitedClass());
        this.elements[id].destroy();

        delete this.elements[id];
    }

    addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        } else {
            element.setAttribute('class', element.getAttribute('class') + ' ' + className);
        }
    }

    removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        } else {
            element.setAttribute('class', element.getAttribute('class').replace(className, ''));
        }
    }

    hasClass(element, className) {
        if (element.classList) {
            return element.classList.contains(className);
        } else {
            return element.getAttribute('class').indexOf(className) >= 0;
        }
    }
}



// WEBPACK FOOTER //
// ./app/general/js/generic.factory.js